import { parseISO, format, getYear, isToday, isTomorrow, isYesterday } from "date-fns";

interface Options {
  shortYear?: boolean;
}

export function humanDate(dateStr: Date | string, { shortYear = false }: Options = {}) {
  const date = typeof dateStr === "string" ? parseISO(dateStr) : dateStr;
  if (isToday(date)) {
    return "Today";
  }
  if (isTomorrow(date)) {
    return "Tomorrow";
  }
  if (isYesterday(date)) {
    return "Yesterday";
  }
  if (getYear(date) === getYear(new Date())) {
    return format(date, "E do MMM");
  } else {
    return format(date, `E do MMM ${shortYear ? "yy" : "yyyy"}`);
  }
}
